import React from "react";
import { NumericFormat } from "react-number-format";

//TODO: Replace react-number-format with slotProps when MUI package updated
export const CommaNumberInput = React.forwardRef<
  HTMLInputElement,
  {
    onChange: (event: { target: { value: number | undefined } }) => void;
    name?: string;
    value: number | string;
  }
>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator
      allowNegative={false}
      valueIsNumericString
      decimalScale={0}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.floatValue ?? undefined,
          },
        });
      }}
    />
  );
});
